import { render, staticRenderFns } from "./TimeSlotsClients.vue?vue&type=template&id=86ffa9a6&scoped=true"
import script from "./TimeSlotsClients.vue?vue&type=script&lang=js"
export * from "./TimeSlotsClients.vue?vue&type=script&lang=js"
import style0 from "./TimeSlotsClients.vue?vue&type=style&index=0&id=86ffa9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ffa9a6",
  null
  
)

export default component.exports